export default __webpack_public_path__ + "static/thumb-landscape-101720ad4e156cd551ff6cc5ab90a7b5.jpg";